import { render, staticRenderFns } from "./imagetable.vue?vue&type=template&id=b5fb4304&"
import script from "./imagetable.vue?vue&type=script&lang=js&"
export * from "./imagetable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports